/** Города, где доступна доставка партнёрами (Достависта). Синхрон с be/src/delivery/constants/dostavista-cities.constant.ts */
const MARKETPLACE_DELIVERY_CITIES = [
  'Москва',
  'Краснодар',
  'Санкт-Петербург',
  'Екатеринбург',
  'Нижний Тагил',
  'Новосибирск',
  'Казань',
  'Нижний Новгород',
  'Челябинск',
  'Омск',
  'Владимир',
  'Ростов-на-Дону',
  'Таганрог',
  'Шахты',
  'Уфа',
  'Самара',
  'Сызрань',
  'Тольятти',
  'Ульяновск',
  'Пермь',
  'Волгоград',
  'Саратов',
  'Воронеж',
  'Красноярск',
  'Архангельск',
  'Астрахань',
  'Барнаул',
  'Брянск',
  'Иваново',
  'Ижевск',
  'Иркутск',
  'Калининград',
  'Калуга',
  'Кемерово',
  'Киров',
  'Кострома',
  'Курган',
  'Курск',
  'Липецк',
  'Мурманск',
  'Набережные Челны',
  'Новокузнецк',
  'Новый Уренгой',
  'Орел',
  'Оренбург',
  'Пенза',
  'Петрозаводск',
  'Псков',
  'Рязань',
  'Смоленск',
  'Сочи',
  'Ставрополь',
  'Сургут',
  'Тамбов',
  'Тверь',
  'Томск',
  'Тула',
  'Тюмень',
  'Хабаровск',
  'Чебоксары',
  'Ярославль',
] as const;

function normalizeCityName(city: string): string {
  return city.trim().toLowerCase().replace(/ё/g, 'е');
}

const MARKETPLACE_DELIVERY_CITY_SET = new Set(
  MARKETPLACE_DELIVERY_CITIES.map((city) => normalizeCityName(city)),
);

export function isMarketplaceDeliveryCity(city: string): boolean {
  return MARKETPLACE_DELIVERY_CITY_SET.has(normalizeCityName(city));
}
